import React, { useState } from 'react'
import "./Notification.css"
import Navbar from '../Navbar/Navbar'
import Upcomming_test from './Upcomming test/Upcomming_test'
import Batch_starting_date from './Batch_starting_date/Batch_starting_date'

const Notification = () => {

  const [tab, setTab] = useState("test");

  const handleTest = (e) => {
    e.preventDefault();
    setTab('test');
  }
  const handleBatch = (e) => {
    e.preventDefault();
    setTab('batch');
  }

  return (
    <>
        <Navbar/>
        <div className='notifications__main__container'>
            <div className='notifications__container'>
                <div className='notification__select'>
                    <div className='notifications__options' style={{backgroundColor: tab === 'test' ? "#F4F4FF" : "#ffff"}} onClick={(e) => handleTest(e)}>Upcoming Test</div>
                    <div className='notifications__options' style={{backgroundColor: tab === 'batch' ? "#F4F4FF" : "#ffff"}} onClick={(e) => handleBatch(e)}>Batch Starting date</div>
                </div>
                <hr></hr>
                {tab === 'test' ? <Upcomming_test /> : <Batch_starting_date/>}
            </div>
        </div>
    </>
  )
}

export default Notification
